import './footer.css'

const Footer = () => {

    return (
        <footer>
            <div className='icons'>
                <a href='https://github.com/azerous1' className='icons zoom fab fa-github'>{}</a>
                <a href='https://www.linkedin.com/in/yichi-zhang-107bba173/' className='icons zoom fab fa-linkedin'>{}</a>
            </div>
            <p className='copyright'>Designed and Built by Yichi</p>
        </footer>
    )
}

export default Footer;